{
  "name": "@seamless/logger",
  "version": "7.5.0",
  "description": "Seamless logger",
  "types": "./dist/index.d.ts",
  "type": "module",
  "exports": {
    "node": {
      "import": "./dist/server/index.js",
      "types": "./dist/server/index.d.ts"
    },
    "default": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "scripts": {
    "test:dev": "vitest",
    "test": "vitest run --coverage",
    "test:nocache": "jest --no-cache --coverage --passWithNoTests",
    "build": "tsdown --environment NODE_ENV:production -c tsdown.config.ts",
    "lint:list": "eslint src/**/*.ts --fix --ignore-pattern '!node_modules/*'",
    "lint": "eslint src/**/*.ts --ignore-pattern '!node_modules/*'",
    "precommit:lint": "lint-staged"
  },
  "keywords": [],
  "author": "",
  "license": "ISL",
  "publishConfig": {
    "scope": "@seamless"
  },
  "devDependencies": {
    "tsdown": "^0.13.3",
    "@gfx/zopfli": "1.0.15",
    "@seamless/config": "8.0.0",
    "@seamless/eslint-config": "9.1.0",
    "@seamless/rollup-plugin-list-licenses": "^0.12.0",
    "@types/node": "^22.18.6",
    "@vitest/coverage-v8": "^3.2.4",
    "concurrently": "^9.2.1",
    "eslint": "^9.37.0",
    "jsdom": "^26.1.0",
    "lint-staged": "^15.5.2",
    "prettier": "^3.5.3",
    "typescript": "^5.9.3",
    "vite": "^6.3.6",
    "vitest": "^3.2.4"
  },
  "dependencies": {
    "@datadog/browser-logs": "^6.21.0",
    "winston": "3.17.0"
  }
}
